import moment from "./moment"
import es from "./es"

moment.defineLocale('es', es);
moment.locale('en');
export default moment;

